module.exports = __webpack_public_path__ + "static/img/1.163322f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/2/zh/1.png
// module id = 2AVj
// module chunks = 0